<template>
  <div>
    <div v-if="!$store.state.global.category" class="text-center mt-3">
      <b-spinner></b-spinner>
    </div>
    <div v-else>
      <app-header
        :title="$store.state.global.category.name"
        :subtitle="'Media Category #' + $store.state.global.category.id"
      >
        <b-button
          v-router-link="{ name: 'mediacategory-editor', query: { id: $route.params.id } }"
          variant="primary"
        >
          <i class="fa fa-pencil-square-o" style="font-size:20px" /> Edit Category
        </b-button>
      </app-header>
      <b-container>
        <b-nav tabs class="mb-3">
          <b-nav-item :to="{ name: 'mediacategory-profile-tab' }">
            Profile
          </b-nav-item>
          <b-nav-item
            v-if="$store.state.global.stickers"
            :to="{ name: 'mediacategory-stickers-tab' }"
          >
            ({{ $store.state.global.stickers.length }}) Stickers
          </b-nav-item>
          <b-nav-item v-if="$store.state.global.themes" :to="{ name: 'mediacategory-themes-tab' }">
            ({{ $store.state.global.themes.length }}) Themes
          </b-nav-item>
        </b-nav>

        <div>
          <router-view />
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import $api from "@/services/api";
import AppHeader from "@/components/AppHeader";

export default {
  components: {
    AppHeader
  },

  created() {
    this.$store.commit("global/clearAll");
    this.refreshData();
  },

  methods: {
    refreshData() {
      const categoryId = this.$route.params.id;

      $api.get(`/v1/internal/mediacategories/${categoryId}`).then(category => {
        this.$store.commit("global/setCategory", category);
      });

      $api.get(`/v1/internal/stickers?category_id=${categoryId}`).then(stickers => {
        this.$store.commit("global/setStickers", stickers);
      });

      $api.get(`/v1/internal/themes?category_id=${categoryId}`).then(themes => {
        this.$store.commit("global/setThemes", themes);
      });
    }
  }
};
</script>
